export function isObjectEmpty(obj) {
  return JSON.stringify(obj) === "{}";
}
